import { FilterDocument, GoalFilterDocument } from './filter-document';
import { GoalMetaData } from './goal-meta-data';
import { GoalMetric } from './goal-metric';
import { IconFormNames } from './icon-names';
import { ID } from './id';
import { Image, NewImage } from './image';
import { LinkedItemSection } from './linked-item-section';
import { Roles } from './roles';
import { GoalSortingMode, GroupByMode, SortingMode } from './sorting-mode';
import { Timestamp } from './timestamp';

export enum ImpactLevel {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}

export type Goal = {
  id: ID;
  name: string;
  description?: string | null;
  iconName: IconFormNames | null;
  image: Image | null;
  color?: string | null;
  startDate: Timestamp | null;
  deadline: Timestamp | null;
  metric: GoalMetric | null;
  sections: LinkedItemSection[] | null;
  lifeAreaId: ID | null;
  parentIds: ID[] | null;
  taskCount: number | null;
  completedTaskCount: number | null;
  sortingMode: SortingMode;
  collapsedSubGoals?: ID[] | null;
  taskSortingMode?: SortingMode;
  filterDocument?: FilterDocument | null;
  customTaskOrder?: Partial<
    Record<
      Exclude<GroupByMode, GroupByMode.None | GroupByMode.LifeArea>,
      Record<ID, ID[]> | null
    >
  >;
  taskSorting: ID[] | null;
  goalSortingMode?: GoalSortingMode;
  goalSorting: ID[] | null;
  goalFilterDocument?: GoalFilterDocument | null;
  roles: Roles;
  frozenAt: Timestamp | null;
  completedAt: Timestamp | null;
  archivedAt: Timestamp | null;
  updatedAt: Timestamp | null;
  createdAt: Timestamp;
  metadata?: GoalMetaData | null;
  // only present on tasks made with the entry goal
  excludedFromLimits?: boolean | null;
  showRoadmap?: boolean | null;
  hideCompletedTasks?: boolean | null;
  impact?: ImpactLevel | null;
};

export type NewGoal = {
  name: string;
  iconName?: IconFormNames | null;
  image?: NewImage | null;
  lifeAreaId?: ID | null;
  color?: string | null;
  startDate?: Timestamp | null;
  deadline?: Timestamp | null;
  metric?: GoalMetric | null;
  parentIds?: ID[] | null;
  taskCount?: number | null;
  completedTaskCount?: number | null;
  taskSorting?: ID[] | null;
};

export type NewGoalWithID = NewGoal & {
  id: ID; // temp ID
};

export type UpdateGoal = Partial<Goal> & Required<Pick<Goal, 'id'>>;
